/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAcceptedCreditRequestRequest } from '../../models/create-accepted-credit-request-request';
import { CreditRequestDto } from '../../models/credit-request-dto';

export interface CreateAcceptedCreditRequest$Params {
  'X-API-Version'?: string;
      body: CreateAcceptedCreditRequestRequest
}

export function createAcceptedCreditRequest(http: HttpClient, rootUrl: string, params: CreateAcceptedCreditRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestDto>> {
  const rb = new RequestBuilder(rootUrl, createAcceptedCreditRequest.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreditRequestDto>;
    })
  );
}

createAcceptedCreditRequest.PATH = '/api/credit-requests';
